<template>
  <div class="item">
    <Left />
    <Right />
  </div>
</template>

<script>
import Left from './Left'
import Right from './Right'
export default {
  components: {
    Left,
    Right
  }
}
</script>
